import React, { useState } from 'react';
import { useLanguage } from '../../context/LanguageContext';
import { ArrowLeft, SkipForward, ThumbsUp, ThumbsDown } from 'lucide-react';
import { hotSeatQuestions } from '../../data/mockData';

export default function HotSeat({ onBack }) {
  const { t } = useLanguage();
  const [currentIndex, setCurrentIndex] = useState(0);
  const [votes, setVotes] = useState({ up: 0, down: 0 });
  const [hasVoted, setHasVoted] = useState(false);

  const currentQ = hotSeatQuestions[currentIndex % hotSeatQuestions.length];

  const handleVote = (type) => {
    if (hasVoted) return;
    setVotes(prev => ({ ...prev, [type]: prev[type] + 1 }));
    setHasVoted(true);
  };

  const nextQuestion = () => {
    setCurrentIndex(prev => prev + 1);
    setVotes({ up: 0, down: 0 });
    setHasVoted(false);
  };

  return (
    <div data-testid="hot-seat-game" className="p-4">
      <button data-testid="game-back-btn" onClick={onBack}
        className="flex items-center gap-2 text-slate-400 hover:text-white transition-colors mb-4 text-sm">
        <ArrowLeft className="w-4 h-4" /> Back to games
      </button>
      <div className="text-center mb-6">
        <div className="text-4xl mb-2">{'\u{1F3AF}'}</div>
        <h3 className="font-display text-xl font-bold">{t('hotSeat')}</h3>
        <p className="text-xs text-slate-400 mt-1">Question {currentIndex + 1}</p>
      </div>
      <div className="glass-card rounded-2xl p-6 text-center mb-6">
        <p className="text-lg font-medium leading-relaxed">{currentQ}</p>
      </div>
      <div className="flex justify-center gap-4 mb-4">
        <button data-testid="vote-up-btn" onClick={() => handleVote('up')}
          className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all ${hasVoted ? 'opacity-50' : 'hover:bg-emerald-500/20'} bg-emerald-500/10 text-emerald-400`}>
          <ThumbsUp className="w-5 h-5" /> {votes.up}
        </button>
        <button data-testid="vote-down-btn" onClick={() => handleVote('down')}
          className={`flex items-center gap-2 px-6 py-3 rounded-full transition-all ${hasVoted ? 'opacity-50' : 'hover:bg-red-500/20'} bg-red-500/10 text-red-400`}>
          <ThumbsDown className="w-5 h-5" /> {votes.down}
        </button>
      </div>
      <div className="flex justify-center gap-3">
        <button data-testid="skip-btn" onClick={nextQuestion}
          className="px-6 py-2 rounded-full bg-white/5 hover:bg-white/10 text-sm flex items-center gap-2 transition-all">
          <SkipForward className="w-4 h-4" /> {t('skip')}
        </button>
        <button data-testid="next-btn" onClick={nextQuestion}
          className="px-6 py-2 rounded-full gradient-button text-sm">
          {t('next')}
        </button>
      </div>
    </div>
  );
}
